export default __webpack_public_path__ + "static/media/TriviaSansBook.fb8a5363.otf";